import { Controller, type Control } from "react-hook-form";
import { Select } from "antd";
import { Input } from "../../../../shared/components/ui/form/inputs";
import { ProgramStudentFormValues } from "../../../academyProgramDetail/hooks/students/useUpdateProgramStudent";

export default function EditProgramStudentFormFull({
  control,
}: {
  control: Control<ProgramStudentFormValues>;
}) {
  return (
    <div className="flex flex-col gap-3">
      <Input
        style={{ background: "none" }}
        control={control}
        label="Nombre"
        name="first_name"
      />
      <Input
        style={{ background: "none" }}
        control={control}
        label="Apellido"
        name="last_name"
      />
      <Input
        style={{ background: "none" }}
        control={control}
        label="Email"
        name="email"
      />
      <Input
        style={{ background: "none" }}
        control={control}
        label="Teléfono"
        name="phone"
      />
      <Input
        style={{ background: "none" }}
        control={control}
        label="Código estudiantil"
        name="student_code"
      />
      <Controller
        control={control}
        name="status"
        render={({ field, fieldState }) => (
          <div>
            <label>Estado en el programa</label>
            <Select
              {...field}
              showSearch
              style={{ width: "100%" }}
              placeholder="Estado del estudiante"
              optionFilterProp="label"
              options={[
                { value: "active", label: "Activo" },
                { value: "inactive", label: "Inactivo" },
                { value: "pause", label: "Pausado" },
                { value: "completed", label: "Completado" },
              ]}
            />
            {fieldState.error ? (
              <span className="mt-1 block text-xs text-red-500">
                {fieldState.error.message}
              </span>
            ) : null}
          </div>
        )}
      />
    </div>
  );
}
